import classNames from 'classnames';
import { useFormattedFormGroupLabel } from 'components/shared/FormGroup/useFormatFormGroupLabel';
import { FC } from 'react';
import styled from 'styled-components';

import type { CommonFormGroupProps } from './model';

const StyledLabel = styled.label`
  max-width: 11rem;
`;

export const BarFormGroup: FC<CommonFormGroupProps> = ({ inputId, label, labelContent, children, className }) => {
  const labelText = useFormattedFormGroupLabel({ label, inputId });

  return (
    <div className={classNames('d-flex mr-3 justify-content-between align-items-center', className)}>
      <StyledLabel className="me-2 mb-0 text-secondary" htmlFor={inputId}>
        {labelText}
        {labelContent}
      </StyledLabel>
      <div className="d-flex flex-wrap justify-content-start align-items-center">{children}</div>
    </div>
  );
};

BarFormGroup.displayName = 'BarFormGroup';
